/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Carriers API
 * Carrier-facing API for the carrier portal (carriers.freightsimple.com).  Authentication: a carrier opens a permanent signed login link, exchanges it for a session token, and presents that token as a bearer on every other call. `CarrierPortalAuthenticationFilter` validates the session and scopes each request to one carrier. Operations use `security: []` (no Micronaut JWT) — the filter is the authenticator, the same model the agents API uses.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ShipmentDocument } from "./ShipmentDocument";
import {
  ShipmentDocumentFromJSON,
  ShipmentDocumentFromJSONTyped,
  ShipmentDocumentToJSON,
  ShipmentDocumentToJSONTyped,
} from "./ShipmentDocument";

/**
 *
 * @export
 * @interface ShipmentDocumentsResponse
 */
export interface ShipmentDocumentsResponse {
  /**
   *
   * @type {Array<ShipmentDocument>}
   * @memberof ShipmentDocumentsResponse
   */
  documents: Array<ShipmentDocument>;
}

/**
 * Check if a given object implements the ShipmentDocumentsResponse interface.
 */
export function instanceOfShipmentDocumentsResponse(
  value: object,
): value is ShipmentDocumentsResponse {
  if (!("documents" in value) || value["documents"] === undefined) return false;
  return true;
}

export function ShipmentDocumentsResponseFromJSON(
  json: any,
): ShipmentDocumentsResponse {
  return ShipmentDocumentsResponseFromJSONTyped(json, false);
}

export function ShipmentDocumentsResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ShipmentDocumentsResponse {
  if (json == null) {
    return json;
  }
  return {
    documents: (json["documents"] as Array<any>).map(ShipmentDocumentFromJSON),
  };
}

export function ShipmentDocumentsResponseToJSON(
  json: any,
): ShipmentDocumentsResponse {
  return ShipmentDocumentsResponseToJSONTyped(json, false);
}

export function ShipmentDocumentsResponseToJSONTyped(
  value?: ShipmentDocumentsResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    documents: (value["documents"] as Array<any>).map(ShipmentDocumentToJSON),
  };
}
